import { createSelector } from 'reselect';

const innerStateSelector = state => state.ageVerification

const isOpenAgeVerificationProcessModalSelector = createSelector(
   innerStateSelector,
   (state) => state.isOpenAgeVerificationProcessModal
)

const isOpenAgeVerifiedModalSelector = createSelector(
   innerStateSelector,
   (state) => state.isOpenAgeVerifiedModal
)

export {
   isOpenAgeVerificationProcessModalSelector,
   isOpenAgeVerifiedModalSelector,
}
